var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-sm-6 col-md-6" },
    [
      _c("h2", [_vm._v(_vm._s(_vm.title_legalnotices[_vm.getCurrentLocale]))]),
      _vm._v(" "),
      _c("ul", { staticClass: "discover triangle hover row" }, [
        _c("li", { staticClass: "col-xs-6" }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.call_getwebcomponent("AGB")
                },
              },
            },
            [_vm._v(_vm._s(_vm.listpoint_agb[_vm.getCurrentLocale]))]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "col-xs-6" }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.call_getwebcomponent("IMPRINT")
                },
              },
            },
            [_vm._v(_vm._s(_vm.listpoint_impressum[_vm.getCurrentLocale]))]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "col-xs-6" }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.call_getwebcomponent("PCPE")
                },
              },
            },
            [_vm._v(_vm._s(_vm.infosprivacypolicy[_vm.getCurrentLocale]))]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "size-modal",
            transition: "nice-modal-fade",
            classes: "demo-modal-class",
            "min-width": 200,
            "min-height": 200,
            "pivot-y": 0.5,
            adaptive: true,
            scrollable: true,
            reset: true,
            height: "auto",
          },
          on: {
            "before-open": _vm.beforeOpen,
            opened: _vm.opened,
            closed: _vm.closed,
            "before-close": _vm.beforeClose,
          },
        },
        [
          _c("div", { staticClass: "size-modal-content" }, [
            _c("h2", [_vm._v(_vm._s(_vm.webcomponenttype))]),
            _vm._v(" "),
            _vm.sections.length > 1
              ? _c(
                  "span",
                  _vm._l(_vm.sections, function (section, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "toggle-container box",
                        staticStyle: { "margin-bottom": "0px" },
                        attrs: { id: "accordion1" },
                      },
                      [
                        _c("div", { staticClass: "panel style1" }, [
                          _c("h4", { staticClass: "panel-title" }, [
                            _c(
                              "a",
                              {
                                staticClass: "collapsed",
                                attrs: {
                                  href: "#acc1_" + index,
                                  "data-toggle": "collapse",
                                  "data-parent": "#accordion1",
                                },
                              },
                              [_vm._v(_vm._s(section.title))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "panel-collapse collapse",
                              attrs: { id: "acc1_" + index },
                            },
                            [
                              _c("div", { staticClass: "panel-content" }, [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(section.content),
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    )
                  })
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.sections.length === 1
              ? _c("span", [
                  _c("div", { staticClass: "panel style1" }, [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.sections[0].content) },
                    }),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }